import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    component:() => import('@/views/huamian/main.vue')
  },
  {
    path:'/shandong/dayangyangji',
    component: () => import('@/views/huamian/shandong/DaYangYangji.vue')
  },
  {
    path:'/shandong/weichengyangji',
    component: () => import('@/views/huamian/shandong/WeiChengYangJi.vue')
  },
  // {
  //   path:'/shandong/dayangyangji/shoufei',
  //   component: () => import('@/views/huamian/shandong/DaYangYangJiShouFei.vue')
  // },
  // {
  //   path:'/shandong/dayangyangji/test',
  //   component: () => import('@/views/huamian/shandong/TestPro.vue')
  // },
  // {
  //   path:'/shanxi/zhongjiaokeji',
  //   component: () => import('@/views/huamian/shanxi/ZhongJiaoKeJiCheng.vue')
  // },
  // {
  //   path:'/fujian/ningdefaremenzhen',
  //   component: () => import('@/views/huamian/fujian/NingDeFaReMenZhen.vue')
  // },
 
  {
    path:'/404',
    component: () => import('@/views/NotFoundView.vue')
  },
  {
    path:'*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  routes
})


export default router